import { tw } from "@careinfo/tailwind";
import ExportIcon from "../../../Icons/ExportIcon";

export default function Export() {
  return (
    <button
      className={tw`bg-[#949494] px-6 rounded-md py-1 flex items-center gap-x-2 justify-center text-white focus:outline-none`}
    >
      <span className={tw`block w-4 h-4`}>
        <ExportIcon />
      </span>
      <span className={tw`block text-lg`}>Export</span>
    </button>
  );
}
